import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import React from "react";
import useRequest from "../../../../components/hooks/use-request";
import { CircleLoader } from "react-spinners";
import Icon from "../../../../assets/icons";
import { showToast } from "../../../../components/toast";
interface AgentProfileProps {
  visible: boolean;
  handleClose: () => void;
  id: string;
}

const DeleteRole: React.FC<AgentProfileProps> = ({
  visible,
  handleClose,
  id,
}: any) => {
    const navigate = useNavigate()
  const userToken = localStorage.getItem("token");
  const { makeRequest: getPrivilegeDeletedById, loading } = useRequest(
    `/roles/${id}`,
    "DELETE",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const handleDelete = async () => {
    const [response, statusCode] = await getPrivilegeDeletedById();
    if (statusCode >= 200 && statusCode < 300) {
      showToast(response?.message || "Role deleted successfully", true, {
        position: "top-center",
      });
      navigate(-1);
    } else {
      showToast(
        response?.message ||
          response?.error ||
          "Something went wrong, please try again",
        false,
        {
          position: "top-center",
        }
      );
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      width={500}
      closable={false}
      footer={null}
    >
      <button onClick={handleClose} className="flex ml-auto">
        <Icon name="cancelIcon" />
      </button>
      <h1 className="text-black font-semibold text-[24px] text-center py-5">
        Are you sure you want to delete this privilege?
      </h1>

      <div className="flex gap-8 justify-center items-center mt-5">
        <button
          className="bg-[#FFC6D1] w-full flex justify-center pt-3 rounded-md h-[47px] font-semibold text-[#FF2D55]"
          onClick={handleDelete}
        >
          {loading ? (
            <CircleLoader color="#0979A1" loading={loading} size={20} />
          ) : (
            "Delete"
          )}
        </button>

        <button
          className="bg-[#0979A1] w-full rounded-md h-[47px] font-semibold text-[#fff]"
          type="button"
          onClick={handleClose}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default DeleteRole;
